import { Controller } from "@hotwired/stimulus";

// Scorrimento orizzontale solo quando la tabella non ci sta nello spazio disponibile.
// Senza scorrimento l'intestazione sticky (.table-header-fisso) si blocca in cima alla pagina;
// con lo scorrimento attivo non può farlo, quindi lo si attiva solo quando serve davvero.
// Reagisce ai cambi di larghezza (finestra, menu laterale compresso o esteso), non allo scroll.
export default class extends Controller {
  connect() {
    this.table = this.element.querySelector("table");
    if (!this.table) return;
    this.verifica = this.verifica.bind(this);
    this.osservatore = new ResizeObserver(() => {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(this.verifica);
    });
    this.osservatore.observe(this.element);
    this.osservatore.observe(this.table);
    this.verifica();
  }

  disconnect() {
    this.osservatore?.disconnect();
    cancelAnimationFrame(this.frame);
  }

  // La tabella è larga il 100% ma non meno del suo contenuto minimo: se supera il contenitore non ci sta.
  verifica() {
    const scorre = this.table.offsetWidth > this.element.clientWidth + 1;
    this.element.classList.toggle("table-fit-scroll", scorre);
  }
}
